import React, { useState } from 'react';
import { history, useModel } from '@umijs/max';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Space, Popover, Input, List, AutoComplete } from 'antd';
import { listGames } from '@/services/game';
import { createStyles } from 'antd-style';

interface GameMenuHeaderProps {
  collapsed?: boolean;
}

const useStyles = createStyles(({ css }) => ({
  searchInput: css`
    .ant-input-search-button {
      border: none !important;
      background: transparent !important;
      box-shadow: none !important;
    }

    .ant-input-group-addon {
      background: transparent !important;
      border: none !important;
    }
  `,
  backButton: css`
    :hover {
      color: rgba(84, 84, 84, 0.8);
    }
  `,
}));

const GameMenuHeader: React.FC<GameMenuHeaderProps> = ({ collapsed }) => {
  const { initialState } = useModel('@@initialState');
  const currentGame = initialState?.currentGame;
  const [games, setGames] = useState<API.GameApplication[]>([]);
  const [loading, setLoading] = useState(false);
  const { styles } = useStyles();
  const [inputValue, setInputValue] = useState('');

  const handleBack = () => {
    history.push('/game-list');
  };

  const handleGameSelect = (gameId: string) => {
    // const selectedGame = games.find((game) => game.id === gameId);
    // if (selectedGame) {
    //   localStorage.setItem(gameId, JSON.stringify(selectedGame));
    // }

    const currentPath = history.location.pathname;
    window.open(currentPath.replace(/\/games\/[^/]+/, `/games/${gameId}`), '_blank');
    setInputValue('');
  };

  const loadGames = async () => {
    setLoading(true);
    try {
      const result = await listGames();
      setGames(result);
    } finally {
      setLoading(false);
    }
  };

  // Tạo options cho AutoComplete với filter
  const getFilteredOptions = (searchText: string) => {
    return games
      .filter(
        (game) =>
          game.id !== currentGame?.id && game.name.toLowerCase().includes(searchText.toLowerCase()),
      )
      .map((game) => ({
        value: game.id,
        label: (
          <Space>
            <img
              src={game.icon || '/default-game-icon.png'}
              alt={game.name}
              style={{ width: 24, height: 24, borderRadius: 4 }}
            />
            <span>{game.name}</span>
          </Space>
        ),
      }));
  };

  const handleSearch = (value: string) => {
    setInputValue(value);
    if (!games.length) {
      loadGames();
    }
  };

  return collapsed !== undefined ? (
    <div style={{ padding: '0px 0px 0px' }}>
      {/* Row 1: Back button */}
      <div
        id="row1"
        className={styles.backButton}
        style={{ marginBottom: 12, cursor: 'pointer' }}
        onClick={handleBack}
      >
        <Space>
          <ArrowLeftOutlined
            style={{
              fontSize: '16px',
              // color: '#666',
            }}
          />
          {!collapsed && (
            <span
              style={{
                fontSize: '15px',
                fontWeight: 500,
                // color: 'rgba(84, 84, 84, 1)',
                marginLeft: 8,
              }}
            >
              All Games
            </span>
          )}
        </Space>
      </div>

      {/* Divider */}
      <div
        style={{
          height: 1.5,
          backgroundColor: '#e8e8e8',
          margin: '4px -16px 16px -16px',
          width: 'calc(100% + 32px)',
        }}
      />

      {/* Row 2: Current game info */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '4px 8px',
          borderRadius: 6,
          marginBottom: 16,
          cursor: 'auto',
        }}
      >
        <img
          src={currentGame?.icon || '/default-game-icon.png'}
          alt="game icon"
          style={{
            width: collapsed ? 24 : 48,
            height: collapsed ? 24 : 48,
            borderRadius: 4,
            marginRight: collapsed ? 0 : 12,
          }}
        />
        {!collapsed && (
          <span
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
            }}
          >
            {currentGame?.name || 'Game Console'}
          </span>
        )}
      </div>

      {/* Row 3: Game selector AutoComplete */}
      {!collapsed && (
        <AutoComplete
          value={inputValue}
          options={getFilteredOptions(inputValue)}
          style={{ width: '100%' }}
          onSelect={handleGameSelect}
          onFocus={loadGames}
          onChange={handleSearch}
        >
          <Input.Search
            placeholder="Search games..."
            loading={loading}
            variant="borderless"
            style={{
              backgroundColor: 'transparent',
              borderRadius: 6,
            }}
            className={styles.searchInput}
          />
        </AutoComplete>
      )}
    </div>
  ) : (
    <></>
  );
};

export default GameMenuHeader;
